import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../reducers/wfp-core-store.type';
import { setEMEFieldEdited } from '../reducers/wfpEMESessionReducer';

interface FieldState {
    fieldId: string;
    autofilled: boolean;
    edited: boolean;
}

const useFieldHandlers = () => {
    const dispatch = useDispatch();
    const fieldStates = useSelector((state: RootState) => state.emeSession.emeFieldStatus) as FieldState[];
    const formData = useSelector((state: RootState) => state.formDetail.formData);

    const handleFieldChange = (fieldId: string, value: any) => {
        dispatch(setEMEFieldEdited(fieldId));
    };

    const getFieldStatus = (fieldId: string): FieldState => {
        if (formData[fieldId] === null || formData[fieldId] === undefined) {
            return  {fieldId, autofilled: false, edited: false };
        }
        return fieldStates.find(field => field.fieldId === fieldId) || { fieldId, autofilled: false, edited: false };
    };

    return { handleFieldChange, getFieldStatus };
};

export default useFieldHandlers;